<template>
  <chips-skeleton v-if="!isInitialized" />
  <div v-else class="chips">
    <chip
      v-for="(item, index) in items"
      :key="index"
      :image="item?.image"
      :label="
        typeof item === 'string' ? item : item?.label || JSON.stringify(item)
      "
      :secondary-text="secondaryText"
      @chip-selected="onChipClick"
    />
  </div>
</template>

<script setup>
import Chip from './Chip.vue'
import ChipsSkeleton from './ChipsSkeleton.vue'

defineProps({
  // To show skeleton or chips
  isInitialized: {
    type: Boolean,
  },
  // Array of strings or objects (with "label" and "image")
  items: {
    type: Array,
  },
  secondaryText: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['chip-selected'])

function onChipClick(label) {
  emits('chip-selected', label)
}
</script>

<style scoped>
.chips {
  display: flex;
  gap: 10px;
}

@media screen and (max-width: 768px) {
  .chips {
    overflow-x: scroll;
    white-space: nowrap;
  }

  .chips::-webkit-scrollbar {
    display: none;
  }
}
</style>
